module.exports = __webpack_public_path__ + "img/app-store.462b4318.png";